<div *ngIf="!!usefulLinks?.length">
  <h3 class="underline-primary text-light font-weight-bold m-1 mb-4 pb-2">USEFUL LINKS</h3>
  <div class="link-container">
    <div class="p-1 pl-0 col-sm-4 col-lg-3" *ngFor="let usefulLink of usefulLinks">
      <app-useful-link-item [usefulLink]="usefulLink"></app-useful-link-item>
    </div>
  </div>

  <button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
    More results<i class="icon icon-arrow-fwd-sm-link"></i>
  </button>
</div>
